const partial = require('lodash/partial')
const has = require('lodash/has')
const every = require('lodash/every')

/*
 	@requiredKeys {array} - Array with keys that have to exist on the object
	@obj {object} - Object tested for the required keys.
*/

module.exports = function requiredKeys(requiredKeys, obj) {
	return every(requiredKeys, partial(has, obj))
}